import React, { HTMLProps } from 'react';
import { ForecastParameters } from '../../../contexts/investment-robot/ForecastContext';
import { LoadingStateWrapper, LoadingStateWrapperProperties } from '../../general/LoadingStateWrapper';
import { toPrice } from '../../../utils/parsers';
import { useTranslation } from 'react-i18next';
import { ForecastResponse } from '../../../api/robotapi';
import { SummaryEntry } from './ForecastResultsCalculations';


export const ForecastSummaryData: React.FC<{
    forecast?: ForecastResponse; 
    forecastParameters?: ForecastParameters;
    classNameTitle?: string;
    classNameText?: string;
} & LoadingStateWrapperProperties & HTMLProps<HTMLDivElement>
> = ({ className, classNameTitle="mt-8 text-2xl", classNameText, forecast, forecastParameters, isLoading, isError, isFetching, isIdle, ...rest }) => {
    
    const { t } = useTranslation('investment');
    const lastForecast = {
        median: forecast?.forecastExpirationValues.median || 0,
        optimistic: forecast?.forecastExpirationValues.optimistic || 0,
        pessimistic: forecast?.forecastExpirationValues.pessimistic || 0,
    };

    return (
        <LoadingStateWrapper
            isLoading={isLoading}
            isError={isError}
            isFetching={isFetching}
            isIdle={isIdle}
            className={className}
        >
            {lastForecast && forecastParameters && (
                <>
                    <span className={`${classNameTitle} block`}>
                        {t('forecast-screen-calculation-value-title', {
                            year: new Date().getFullYear() + forecastParameters.capitalGoal.inYears,
                        })}
                    </span>
                    <div className={`${classNameText}`}>
                        {lastForecast.median
                            && <SummaryEntry 
                                text={t("forecast-screen-result-expected-market")}
                                value={toPrice(lastForecast?.median, {
                                    onlyFullEuros: true,
                                    withCurrencySymbol: true,
                                })}
                        />}
                        {lastForecast.pessimistic 
                            && <SummaryEntry 
                                text={t("forecast-screen-result-pessimistic-market")}
                                value={toPrice(lastForecast?.pessimistic, {
                                    onlyFullEuros: true,
                                    withCurrencySymbol: true,
                                })}
                        />}
                        {lastForecast.optimistic
                            && <SummaryEntry
                                text={t("forecast-screen-result-optimistic-market")}
                                value={toPrice(lastForecast?.optimistic, {
                                    onlyFullEuros: true,
                                    withCurrencySymbol: true,
                                })}
                        />}
                    </div>
                </>
            )}
        </LoadingStateWrapper>
    );
};
